//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import draggable from './draggable';

  /**
   * @name Range
   * @tagName mt-range
   * @desc 滑块
   * @wrapClassName mint-range
   * @noteType component
   * @html
   * <mt-range></mt-range>
   */
  export default {
    name: 'mt-range',

    props: {
      /**
       * @noteType prop
       * @field min
       * @desc 最小值
       * @type input
       * @valueType number
       * @value 0
       */
      min: {
        type: Number,
        default: 0
      },
      /**
       * @noteType prop
       * @field max
       * @desc 最大值
       * @type input
       * @valueType number
       * @value 100
       */
      max: {
        type: Number,
        default: 100
      },
      /**
       * @noteType prop
       * @field step
       * @desc 步长
       * @type input
       * @valueType number
       * @value 1
       */
      step: {
        type: Number,
        default: 1
      },
      /**
       * @noteType prop
       * @field disabled
       * @desc 是否禁用
       * @valueType boolean
       * @type radio
       * @value false
       * @option
       [{
           "text": "否",
           "value": false
       },{
           "text": "是",
           "value": true
       }]
       */
      disabled: {
        type: Boolean,
        default: false
      },
      /**
       * @noteType prop
       * @field value
       * @desc 默认值
       * @type textarea
        */
      value: {
        type: Number
      },
      /**
       * @noteType prop
       * @field barHeight
       * @desc 滑槽的线宽
       * @type input
       * @valueType number
       * @placeholder 1
       */
      barHeight: {
        type: Number,
        default: 2
      }
    },

    computed: {
      progress() {
        const value = this.value;
        if (typeof value === 'undefined' || value === null) return 0;
        return Math.floor((value - this.min) / (this.max - this.min) * 100);
      }
    },

    mounted() {
      const thumb = this.$refs.thumb;
      const content = this.$refs.content;

      const getThumbPosition = () => {
        const contentBox = content.getBoundingClientRect();
        const thumbBox = thumb.getBoundingClientRect();
        return {
          left: thumbBox.left - contentBox.left,
          top: thumbBox.top - contentBox.top,
          thumbBoxLeft: thumbBox.left
        };
      };

      let dragState = {};
      draggable(thumb, {
        start: (event) => {
          if (this.disabled) return;
          const position = getThumbPosition();
          const thumbClickDetalX = event.clientX - position.thumbBoxLeft;
          dragState = {
            thumbStartLeft: position.left,
            thumbStartTop: position.top,
            thumbClickDetalX: thumbClickDetalX
          };
        },
        drag: (event) => {
          if (this.disabled) return;
          const contentBox = content.getBoundingClientRect();
          const deltaX = event.pageX - contentBox.left - dragState.thumbStartLeft - dragState.thumbClickDetalX;
          const stepCount = Math.ceil((this.max - this.min) / this.step);
          const newPosition = (dragState.thumbStartLeft + deltaX) - (dragState.thumbStartLeft + deltaX) % (contentBox.width / stepCount);

          let newProgress = newPosition / contentBox.width;

          if (newProgress < 0) {
            newProgress = 0;
          } else if (newProgress > 1) {
            newProgress = 1;
          }

          this.$emit('input', Math.round(this.min + newProgress * (this.max - this.min)));
        },
        end: () => {
          if (this.disabled) return;
          this.$emit('change', this.value);
          dragState = {};
        }
      });
    }
  };
/**
 * @noteType external
 * @content
 {
   "mock": {
     "value": 88,
     "min": 0,
     "max": 100,
     "step": 1
   },
   "bindField": "v-model"
 }
 */



// WEBPACK FOOTER //
// ./packages/range/src/range.vue